export enum LookAlikeSourceTypes {
    Segment =  1,
    Audience = 2
}